import React from 'react';
const DIAS = ['DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'];
export function Hero() {
  const diaHoy = DIAS[new Date().getDay()];
  return <section className="bg-[#0F172A] pt-10 sm:pt-18 pb-10 sm:pb-16 px-4 text-center relative overflow-hidden" data-id="element-122">
      <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-gradient-to-r from-transparent via-[#22C55E] via-[#F97316] to-transparent" data-id="element-123" />

      <div className="max-w-[780px] mx-auto" data-id="element-124">
        <p className="font-montserrat text-[11px] font-extrabold tracking-[3px] uppercase text-[#22C55E] mb-5" style={{
        animation: 'fadeUp 0.5s ease both'
      }} data-id="element-125">
          SOLO POR HOY {diaHoy} · 6 BONOS GRATIS · SOLO $16.990
        </p>

        <h1 className="font-montserrat text-[clamp(28px,5.5vw,52px)] font-black leading-[1.1] mb-[18px] text-white tracking-tight" style={{
        animation: 'fadeUp 0.5s 0.08s ease both'
      }} data-id="element-126">
          Fabricá{' '}
          <em className="not-italic text-[#22C55E]" data-id="element-127">20g de Proteína Pura</em>
          <br data-id="element-128" />
          por Menos de $800 en Casa
        </h1>

        <p className="text-[clamp(15px,2.5vw,18px)] text-[#94A3B8] max-w-[540px] mx-auto mb-9 leading-[1.7]" style={{
        animation: 'fadeUp 0.5s 0.16s ease both'
      }} data-id="element-129">
          Sin gastar fortunas en el quiosco. Sin ingredientes imposibles.
          <br data-id="element-130" />
          Con el sistema paso a paso más completo de Argentina.
        </p>

        <img src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/FOTO_BUNDLE.png?v=1776370777" alt="Bundle completo Barrita Pro" className="w-full max-w-[500px] mx-auto mb-10 block rounded-[20px] shadow-[0_24px_60px_rgba(0,0,0,0.55),0_0_0_1px_rgba(34,197,94,0.15)] transition-transform duration-[0.25s] hover:scale-[1.013]" style={{
        animation: 'fadeUp 0.5s 0.24s ease both'
      }} data-id="element-131" />

        <a href="#comprar" className="inline-block bg-[#F97316] text-white font-montserrat text-[15px] font-extrabold uppercase tracking-[1.5px] py-[18px] px-11 rounded-lg border-none cursor-pointer no-underline transition-all duration-[0.25s] hover:bg-[#C2410C] hover:shadow-[0_8px_32px_rgba(249,115,22,0.45)] hover:-translate-y-0.5 active:translate-y-0" style={{
        animation: 'pulse-cta 2.5s ease infinite'
      }} data-id="element-132">
          QUIERO MIS BARRITAS PROTEICAS &gt;&gt;
        </a>

        <p className="text-xs text-[#64748B] mt-[14px] tracking-[0.5px]" data-id="element-133">
          Acceso inmediato · Pago único · Garantía 7 días
        </p>
      </div>
    </section>;
}